import { Comment as CommunityComment } from 'types/comment';
import styles from './CommentReply.module.css';
import Comment from './Comment';
import { CommunityShotItem } from 'types/community';

type Props = {
  reply: CommunityComment;
  shotItem: CommunityShotItem;
  targetCommentId?: number;
};

export default function CommentReply(props: Props) {
  return (
    <div className={styles.CommentReply}>
      <Comment
        shotItem={props.shotItem}
        comment={props.reply}
        repliesEnabled={false}
        targetCommentId={props.targetCommentId}
      />
    </div>
  );
}
